import React, { useState, useEffect } from "react";
import { Rept, sto } from "../../../Context/InshData";
import Grid from "@material-ui/core/Grid";
import HeaderAll from "../../HeaderAll";

function HeaderConferm(props) {

  const { found } = props;
  const styf = { fontWeight: "1200" };

  return (
    <Grid item container
      justifyContent="center"
      style={{
        paddingTop: "1rem", fontWeight: "bold", fontFamily: "Amiri-Regular",
      }}>
      <HeaderAll Report={true}  found={found} />

      <Grid item container style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}>
      <Grid item xs={1}></Grid>
        <Grid item xs={10} style={{
          fontFamily: "Amiri-Regular", border: "solid 2px", paddingTop: "0.5rem",
           paddingBottom: "0.5rem",
          borderRadius: "10px", textAlign: "center", backgroundColor:"#1eFFFF"
        }}
        >
          <div style={styf}>
            {Rept?.title} {"    "} {"من تاريخ"}{"    /"} {Rept?.fDate}{"    "}  {"إلى تاريخ"}{"     /"} {Rept?.tDate}
          </div>
        </Grid>
        <Grid item xs={1}></Grid>

      </Grid>

    </Grid>
  );
}
export default HeaderConferm;